import React from 'react';
import { Helmet } from 'react-helmet';

const Gdpr: React.FC = () => {
  return (
    <div className="space-y-6">
      <Helmet>
        <title>GDPR</title>
      </Helmet>

      <div className="space-y-2">
        <h1 className="text-2xl font-semibold">GDPR</h1>
        <p className="text-sm text-muted-foreground">Ultima actualizare: 11 februarie 2026</p>
      </div>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">1. Informații generale</h2>
        <p className="text-muted-foreground">
          Regulamentul (UE) 2016/679 („GDPR”) stabilește reguli privind protecția datelor cu caracter personal. În Platformă,
          prelucrarea datelor se face conform Politicii de confidențialitate și, după caz, în baza unui acord de împuternicit
          (DPA) pentru implementările B2B.
        </p>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">2. Drepturile tale</h2>
        <div className="space-y-3 text-muted-foreground">
          <p>În condițiile legii, poți avea următoarele drepturi:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>dreptul de acces;</li>
            <li>dreptul la rectificare;</li>
            <li>dreptul la ștergere („dreptul de a fi uitat”);</li>
            <li>dreptul la restricționare;</li>
            <li>dreptul la portabilitate (după caz);</li>
            <li>dreptul la opoziție (în anumite situații);</li>
            <li>dreptul de a depune plângere la ANSPDCP.</li>
          </ul>
        </div>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">3. Cum depui o solicitare</h2>
        <p className="text-muted-foreground">
          Pentru solicitări privind datele, ne poți scrie la <span className="text-foreground">office@globallinknet.ro</span>.
          Pentru implementările B2B, solicitările privind datele educaționale sunt, de regulă, gestionate de școală (Operator).
        </p>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">4. Autoritatea de supraveghere</h2>
        <p className="text-muted-foreground">
          Autoritatea competentă în România este <span className="text-foreground">ANSPDCP</span> (Autoritatea Națională de
          Supraveghere a Prelucrării Datelor cu Caracter Personal).
        </p>
      </section>
    </div>
  );
};

export default Gdpr;

